export const validatePhoneNumber = (phoneNumber?: string) => {
  const regex = new RegExp(/^(\(\d{3}\)\s*\d{3}(?:-|\s*)\d{4}|\+\d{12,})$/);

  return phoneNumber && phoneNumber.length && regex.test(phoneNumber);
};

export const validateEmailAddress = (emailAddress?: string) => {
  const regex = new RegExp(
    /^([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})$/,
  );

  return emailAddress && emailAddress.length && regex.test(emailAddress);
};
